import {
  examFilterOptionListAtom,
  levelFilterOptionListAtom,
  selectedFilterOptionAtom,
  subjectFilterOptionListAtom,
} from '@atom/examResultAtom';
import { DropdownFilter } from 'geniebook-ui/dist';
import { useAtom } from 'jotai';
import React from 'react';

export type selectedOptionType = {
  subject: string;
  level: string;
  type: string;
};

const FilterResultOnWeb = () => {
  const [examFilterOptionList] = useAtom(examFilterOptionListAtom); // is "Type" filter
  const [subjectFilterOptionList] = useAtom(subjectFilterOptionListAtom);
  const [levelFilterOptionList] = useAtom(levelFilterOptionListAtom);

  const [selectedOption, setSelectedOption] = useAtom(selectedFilterOptionAtom);

  const handleSelected =
    (key: keyof selectedOptionType) => (value: string | number) => {
      setSelectedOption(prevState => ({
        ...prevState,
        [key]: value.toString().trim(),
      }));
    };

  const handleSubjectSelected = handleSelected('subject');
  const handleLevelSelected = handleSelected('level');
  const handleTypeSelected = handleSelected('type');

  const filterDropdownConfigs = [
    {
      label: 'Subject',
      options: subjectFilterOptionList,
      selected: selectedOption.subject,
      setSelected: handleSubjectSelected,
    },
    {
      label: 'Level',
      options: levelFilterOptionList,
      selected: selectedOption.level,
      setSelected: handleLevelSelected,
    },
    {
      label: 'Type',
      options: examFilterOptionList,
      selected: selectedOption.type,
      setSelected: handleTypeSelected,
    },
  ];

  return (
    <div className="z-[99] mr-1 flex w-8/12 gap-2">
      {filterDropdownConfigs.map((config, index) => (
        <DropdownFilter
          key={index}
          label={config.label}
          options={config.options}
          selected={config.selected}
          setSelected={config.setSelected}
          width="w-[33%]"
          classNameBase="w-1/3 min-w-0"
          classNameLabel="flex w-5/6 flex-row gap-1 [&>span:last-child]:block [&>span:last-child]:truncate [&>span:last-child]:text-ellipsis"
        />
      ))}
    </div>
  );
};

export default FilterResultOnWeb;
